import { render, staticRenderFns } from "./CertificadoEditarForm.vue?vue&type=template&id=61ba0bda"
import script from "./CertificadoEditarForm.vue?vue&type=script&lang=js"
export * from "./CertificadoEditarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports